/**
 * SchemaGhostToggle — the schema-ghost diagnostic as an engine window.
 *
 * Phase 3: the schema-ghost is a pure side-effect toggle (no panel UI) that
 * used to live behind DiagnosticsContext.showSchemaGhost — a useEffect there
 * flipped `window.__HELIX_SCHEMA_GHOST__`, which PlayerRenderer reads to draw a
 * translucent ghost at the local player's SERVER schema position (drift
 * visualizer).
 *
 * Folding it into the unified window engine keeps DiagnosticsContext deletable.
 * The engine's WindowHost mounts a window's content ONLY while it is open and
 * unmounts it when closed, so a mount/unmount effect is the exact lifecycle the
 * old `[showSchemaGhost]` effect had: global true while the window is open,
 * cleared when it closes.
 *
 * It renders nothing visible — the ToolWindow chrome WindowHost wraps it in is
 * the toggle affordance (and the 🛠 launcher row drives the open-set). jsdom
 * guards carried forward.
 */

import { useEffect } from 'react';
import type React from 'react';

export const SchemaGhostToggle: React.FC = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    (window as unknown as { __HELIX_SCHEMA_GHOST__?: boolean }).__HELIX_SCHEMA_GHOST__ = true;
    return () => {
      (window as unknown as { __HELIX_SCHEMA_GHOST__?: boolean }).__HELIX_SCHEMA_GHOST__ = false;
    };
  }, []);
  return null;
};
